export enum OfferPriceTestIds {
    SKELETON = "offer-price-skeleton"
}